import { n as ie } from "./Logger-CmiOOsKC.js";
var xe = 1e-6;
function b(e = 0, t = 0, s = 0) {
  return {
    x: e,
    y: t,
    z: s
  };
}
function oe() {
  return {
    size: b(1, 1, 1),
    sizeMode: {
      x: "Hug",
      y: "Hug",
      z: "Hug"
    },
    min: b(0, 0, 0),
    max: b(1 / 0, 1 / 0, 1 / 0)
  };
}
function ne(e = 0) {
  return {
    left: e,
    right: e,
    top: e,
    bottom: e,
    front: e,
    back: e
  };
}
function re() {
  return {
    directionAxis: "Y",
    gap: 0,
    padding: ne(0),
    alignMain: "Start",
    alignCrossA: "Start",
    alignCrossB: "Center",
    alignContentCrossA: "Start",
    alignContentCrossB: "Start"
  };
}
function Q() {
  return {
    mainAxisMode: "Hug",
    flexGrow: 0,
    flexShrink: 1,
    flexBasis: null,
    order: 0,
    alignSelfCross: void 0,
    alignSelfCrossB: void 0
  };
}
function ae() {
  return `node_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`;
}
function le(e) {
  return {
    id: e ?? ae(),
    parentId: null,
    childrenIds: [],
    position: b(),
    rotation: b(),
    layoutBox: oe(),
    layoutItem: null,
    layoutContainer: null,
    resolvedSize: b(),
    resolvedPosition: b()
  };
}
function ce(e, t, s) {
  if (e.x < t.x || e.y < t.y || e.z < t.z) throw new Error(`Layout invariant violated: Node ${s} resolvedSize (${e.x}, ${e.y}, ${e.z}) is below minSize (${t.x}, ${t.y}, ${t.z})`);
}
function de(e, t) {
  if (isNaN(e.x) || isNaN(e.y) || isNaN(e.z)) throw new Error(`Layout invariant violated: NaN in ${t}: (${e.x}, ${e.y}, ${e.z})`);
  if (e.x < 0 || e.y < 0 || e.z < 0) throw new Error(`Layout invariant violated: Negative dimension in ${t}: (${e.x}, ${e.y}, ${e.z})`);
}
function fe(e, t) {
  if (!isFinite(e.x) || !isFinite(e.y) || !isFinite(e.z)) throw new Error(`Layout invariant violated: Non-finite position for node ${t}: (${e.x}, ${e.y}, ${e.z})`);
}
function ue(e) {
  de(e.resolvedSize, `node ${e.id} resolvedSize`), ce(e.resolvedSize, e.layoutBox.min, e.id), fe(e.resolvedPosition, e.id);
}
var T = /* @__PURE__ */ new Set();
function V(e, t, s) {
  const i = `[Layout] Unknown ${e} "${t}" — expected 'X', 'Y' or 'Z'. ${s}`;
  T.has(i) || (T.add(i), ie.warn(i));
}
var he = {
  start: "Start",
  "flex-start": "Start",
  left: "Start",
  top: "Start",
  center: "Center",
  end: "End",
  "flex-end": "End",
  right: "End",
  bottom: "End",
  stretch: "Stretch",
  spacebetween: "SpaceBetween",
  "space-between": "SpaceBetween",
  spacearound: "SpaceAround",
  "space-around": "SpaceAround",
  spaceevenly: "SpaceEvenly",
  "space-evenly": "SpaceEvenly"
};
function Z(e, t, s, i) {
  if (e == null) return s;
  if (t.includes(e)) return e;
  const o = typeof e == "string" ? he[e.trim().toLowerCase()] : void 0;
  if (o !== void 0 && t.includes(o)) return o;
  const n = `[Layout] Unknown ${i} "${e}" — using '${s}'.`;
  return T.has(n) || (T.add(n), ie.warn(n)), s;
}
var j = [
  "Start",
  "Center",
  "End",
  "Stretch"
], _ = [
  "Start",
  "Center",
  "End",
  "SpaceBetween",
  "SpaceAround",
  "SpaceEvenly"
];
function ze(e) {
  e.alignMain = Z(e.alignMain, _, "Start", "alignMain"), e.alignCrossA = Z(e.alignCrossA, j, "Start", "alignCross"), e.alignCrossB = Z(e.alignCrossB, j, "Start", "alignCrossB"), e.alignContentCrossA !== void 0 && (e.alignContentCrossA = Z(e.alignContentCrossA, _, "Start", "alignContent")), e.alignContentCrossB !== void 0 && (e.alignContentCrossB = Z(e.alignContentCrossB, _, "Start", "alignContentCrossB"));
}
function ge(e) {
  e.alignSelfCross !== void 0 && (e.alignSelfCross = Z(e.alignSelfCross, j, "Start", "alignSelfCross")), e.alignSelfCrossB !== void 0 && (e.alignSelfCrossB = Z(e.alignSelfCrossB, j, "Start", "alignSelfCrossB"));
}
function Se(e) {
  switch (e) {
    case "X":
      return ["Y", "Z"];
    case "Y":
      return ["X", "Z"];
    case "Z":
      return ["X", "Y"];
    default:
      return V("directionAxis", e, "Falling back to the X-axis cross pair ['Y', 'Z']."), ["Y", "Z"];
  }
}
function K(e) {
  const [t, s] = Se(e.directionAxis);
  return e.wrap === !0 && e.wrapAxis === s ? [s, t] : [t, s];
}
function z(e, t) {
  switch (t) {
    case "X":
      return e.x;
    case "Y":
      return e.y;
    case "Z":
      return e.z;
    default:
      return V("axis", t, "Reading no component — the arithmetic downstream goes NaN."), NaN;
  }
}
function A(e, t, s) {
  const i = { ...e };
  switch (t) {
    case "X":
      i.x = s;
      break;
    case "Y":
      i.y = s;
      break;
    case "Z":
      i.z = s;
      break;
    default:
      V("axis", t, "Writing no component — the vector is returned unchanged.");
      break;
  }
  return i;
}
var ye = {
  getIntrinsicSize: () => b(100, 100, 100),
  getMinSize: () => b(0, 0, 0)
}, R = 1e-6;
function ee(e, t, s) {
  if (e.fit === "none") return 1;
  const i = [];
  if (s.x != null && s.x > R && t.x > R && i.push(s.x / t.x), s.y != null && s.y > R && t.y > R && i.push(s.y / t.y), i.length === 0) return 1;
  let o = Math.min(...i);
  e.fit === "scale-down" && (o = Math.min(o, 1));
  const n = (e.zooms ?? []).filter((a) => a > 0 && a <= o * (1 + 1e-6));
  return n.length > 0 && (o = Math.max(...n)), o;
}
function te(e, t, s, i, o, n = !0) {
  const a = n ? s : 0;
  return e === "Hug" ? Math.max(t, a) : e === "Fixed" || i || o ? t : Math.max(t, a);
}
function D(e, t, s) {
  const i = t - (e.reduce((n, a) => n + a.baseMain, 0) + Math.max(0, e.length - 1) * s), o = /* @__PURE__ */ new Map();
  for (const n of e) o.set(n.id, n.baseMain);
  if (i > 0) {
    const n = new Set(e.filter((a) => a.grow > 0).map((a) => a.id));
    for (let a = 0; a < e.length + 1; a++) {
      let r = 0;
      for (const f of e) n.has(f.id) ? r += f.baseMain : r += o.get(f.id) ?? f.baseMain;
      const l = t - r - Math.max(0, e.length - 1) * s;
      if (l <= 1e-6) break;
      const u = e.filter((f) => n.has(f.id)), c = u.reduce((f, h) => f + h.grow, 0);
      if (c <= 0) break;
      let d = !1;
      for (const f of u) {
        const h = f.grow / c, S = f.baseMain + l * h;
        S < f.minMain - 1e-6 ? (o.set(f.id, f.minMain), n.delete(f.id), d = !0) : S > f.maxMain + 1e-6 ? (o.set(f.id, f.maxMain), n.delete(f.id), d = !0) : o.set(f.id, S);
      }
      if (!d) break;
    }
  } else if (i < 0) {
    let n = -i;
    const a = new Set(e.filter((r) => r.shrink > 0 && r.baseMain > 0).map((r) => r.id));
    for (; n > 1e-6 && a.size > 0; ) {
      const r = e.filter((c) => a.has(c.id)), l = r.reduce((c, d) => c + d.shrink * d.baseMain, 0);
      if (l <= 0) break;
      let u = 0;
      for (const c of r) {
        const d = o.get(c.id) ?? c.baseMain, f = c.shrink * c.baseMain / l, h = n * f, S = Math.max(c.minMain, d - h);
        u += d - S, o.set(c.id, S), S <= c.minMain + 1e-6 && a.delete(c.id);
      }
      if (u <= 1e-6) break;
      n = Math.max(0, n - u);
    }
  }
  return o;
}
function se(e, t, s) {
  return Math.min(s, Math.max(t, e));
}
var me = class {
  intrinsicProvider = ye;
  constraintWasIndefinite = !1;
  getRelativeAxisPercent(e, t) {
    const s = e.layoutItem;
    if (!s) return null;
    const i = t === "X" ? s.widthPercent : t === "Y" ? s.heightPercent : void 0;
    return typeof i == "number" && Number.isFinite(i) ? i : null;
  }
  hasMeasuredContentFloor(e, t) {
    if (e.layoutContainer && e.childrenIds.length === 0) return !1;
    const s = e.layoutBox;
    return !(t === "X" ? s.sizeIsBasisX : t === "Y" ? s.sizeIsBasisY : s.sizeIsBasisZ);
  }
  isAbsolute(e) {
    return e.layoutItem?.positionMode === "Absolute";
  }
  getOrderedChildren(e, t) {
    const s = e.getChildren(t);
    return s.length <= 1 || !s.map((i) => i.layoutItem?.order ?? 0).some((i) => i !== 0) ? s : s.map((i, o) => ({
      c: i,
      i: o,
      order: i.layoutItem?.order ?? 0
    })).sort((i, o) => i.order - o.order || i.i - o.i).map((i) => i.c);
  }
  setIntrinsicProvider(e) {
    this.intrinsicProvider = e;
  }
  computeLayout(e) {
    this.normalizeAlignments(e), this.resolveMainAxisModes(e);
    for (let t = 0; t < 2; t++) {
      this.constraintWasIndefinite = !1, e.traverseBottomUp((s) => this.measure(s, e));
      for (const s of e.getRoots())
        s.resolvedPosition = { ...s.position }, this.resolve(s, e, !1);
      if (!this.constraintWasIndefinite) break;
    }
    e.traverse((t) => ue(t));
  }
  normalizeAlignments(e) {
    for (const t of e.getAllNodes())
      t.layoutContainer && ze(t.layoutContainer), t.layoutItem && ge(t.layoutItem);
  }
  resolveMainAxisModes(e) {
    for (const t of e.getAllNodes()) {
      if (!t.parentId || !t.layoutItem) continue;
      const s = e.getNode(t.parentId);
      if (!s?.layoutContainer) continue;
      const i = s.layoutContainer.directionAxis;
      t.layoutItem.mainAxisMode = t.layoutBox.sizeMode[i === "X" ? "x" : i === "Y" ? "y" : "z"];
    }
  }
  measure(e, t) {
    const s = this.getOrderedChildren(t, e.id);
    e.layoutContainer && s.length > 0 ? this.measureContainer(e, s, t) : e.layoutContainer ? this.measureEmptyContainer(e) : this.measureLeaf(e);
  }
  measureEmptyContainer(e) {
    const t = e.layoutContainer, s = e.layoutBox, i = t.padding;
    s.sizeMode.x === "Hug" && (s.size.x = i.left + i.right), s.sizeMode.y === "Hug" && (s.size.y = i.top + i.bottom), s.sizeMode.z === "Hug" && (s.size.z = i.front + i.back);
  }
  measureLeaf(e) {
    const t = this.intrinsicProvider.getIntrinsicSize(e), s = this.intrinsicProvider.getMinSize(e);
    e.layoutBox.min = {
      x: Math.max(e.layoutBox.min.x, s.x),
      y: Math.max(e.layoutBox.min.y, s.y),
      z: Math.max(e.layoutBox.min.z, s.z)
    };
    const i = e.layoutBox;
    i.sizeMode.x === "Hug" && (i.size.x = t.x), i.sizeMode.y === "Hug" && (i.size.y = t.y), i.sizeMode.z === "Hug" && (i.size.z = t.z);
  }
  measureContainer(e, t, s) {
    const i = e.layoutContainer, o = e.layoutBox, [n, a] = K(i), r = t.filter((g) => !this.isAbsolute(g));
    if (i.wrap === !0) {
      this.measureWrappedContainer(e, r, s, i.directionAxis, n, a);
      return;
    }
    const l = this.fittedChild(e, r);
    if (l) {
      const g = i.padding;
      l.flowScale = ee(i.contentFit, l.layoutBox.size, {
        x: o.sizeMode.x === "Fixed" ? Math.max(0, o.size.x - g.left - g.right) : null,
        y: o.sizeMode.y === "Fixed" ? Math.max(0, o.size.y - g.top - g.bottom) : null
      });
    }
    let u = 0, c = 0, d = 0;
    for (let g = 0; g < r.length; g++) {
      const p = r[g], M = this.flowBox(p, p.layoutBox.size);
      u += z(M, i.directionAxis), g > 0 && (u += i.gap), c = Math.max(c, z(M, n)), d = Math.max(d, z(M, a));
    }
    const f = i.padding, h = this.getMainPadding(i.directionAxis, f), S = this.getMainPadding(n, f), y = this.getMainPadding(a, f);
    u += h, c += S, d += y, o.sizeMode.x === "Hug" && (i.directionAxis === "X" ? o.size.x = u : n === "X" ? o.size.x = c : o.size.x = d), o.sizeMode.y === "Hug" && (i.directionAxis === "Y" ? o.size.y = u : n === "Y" ? o.size.y = c : o.size.y = d), o.sizeMode.z === "Hug" && (i.directionAxis === "Z" ? o.size.z = u : n === "Z" ? o.size.z = c : o.size.z = d);
  }
  buildFlexInputs(e, t, s) {
    const i = t.toLowerCase(), o = /* @__PURE__ */ new Map(), n = [];
    for (const a of e) {
      const r = a.layoutItem, l = a.layoutBox, u = this.getRelativeAxisPercent(a, t), c = u != null ? "Fixed" : r?.mainAxisMode ?? l.sizeMode[i], d = r?.flexBasis ?? null, f = u != null ? s * u / 100 : z(l.size, t), h = u != null ? f : d ?? (c === "Fill" ? 0 : f), S = r?.flexGrow ?? (c === "Fill" ? 1 : 0), y = r?.flexShrink ?? 1, g = te(c, z(l.min, t), f, !!(t === "X" ? l.minExplicitX : t === "Y" ? l.minExplicitY : l.minExplicitZ), a.layoutContainer?.clipContent === !0, this.hasMeasuredContentFloor(a, t)), p = z(l.max, t);
      n.push({
        id: a.id,
        baseMain: h,
        grow: Math.max(0, S),
        shrink: Math.max(0, y),
        minMain: g,
        maxMain: p
      }), o.set(a.id, {
        child: a,
        minMain: g,
        maxMain: p
      });
    }
    return {
      flexes: n,
      childFlexMap: o
    };
  }
  isUnwrappedFlowChild(e, t, s) {
    const i = e.layoutContainer;
    return !i || i.wrap || i.directionAxis !== s ? !1 : !this.isAbsolute(t);
  }
  flowShareOf(e, t, s, i, o) {
    const n = e.getChildren(t.id).filter((d) => !this.isAbsolute(d)), a = i.toLowerCase();
    for (const d of n) d !== s && d.layoutBox.sizeMode[a] === "Hug" && this.getRelativeAxisPercent(d, i) == null && (this.constraintWasIndefinite = !0);
    const { flexes: r, childFlexMap: l } = this.buildFlexInputs(n, i, o), u = D(r, o, t.layoutContainer.gap).get(s.id), c = l.get(s.id);
    return u === void 0 || !c ? o : se(u, c.minMain, c.maxMain);
  }
  measureWrappedContainer(e, t, s, i, o, n) {
    const a = e.layoutContainer, r = e.layoutBox, l = a.padding, u = (x) => x.toLowerCase(), c = (x) => r.sizeMode[u(x)] === "Hug", d = (x) => r.sizeMode[u(x)] === "Fill", f = (x, C) => {
      if (!x.parentId) return null;
      const w = [];
      let k = x;
      for (; k && (w.push(k), !!k.parentId); ) {
        const v = s.getNode(k.parentId) ?? null;
        if (v?.layoutContainer?.contentFit) break;
        k = v;
      }
      const X = u(C), Y = (v) => C === "X" ? v.x : C === "Y" ? v.y : v.z, E = (v) => {
        const N = Y(v.resolvedSize ?? {
          x: 0,
          y: 0,
          z: 0
        });
        if (N > 1e-4) return N;
        const H = v.layoutBox.sizeMode[X], O = Y(v.layoutBox.size), G = O > 1e-4;
        return H === "Fixed" && G ? O : (H === "Hug" && G && (this.constraintWasIndefinite = !0), null);
      };
      let U = -1, $ = 0;
      for (let v = 1; v < w.length; v++) {
        const N = E(w[v]);
        if (N != null && N > 0) {
          U = v, $ = N;
          break;
        }
      }
      if (U === -1) return null;
      for (let v = U; v > 0; v--) {
        const N = w[v], H = w[v - 1];
        let O = $;
        if (N.layoutContainer) {
          const W = N.layoutContainer.padding;
          C === "X" && (O = Math.max(0, O - (W.left + W.right))), C === "Y" && (O = Math.max(0, O - (W.top + W.bottom))), C === "Z" && (O = Math.max(0, O - (W.front + W.back)));
        }
        const G = H.layoutBox.sizeMode[X], J = Y(H.layoutBox.size), q = J > 1e-4;
        G === "Fixed" && q ? $ = Math.min(O, J) : G === "Fill" && this.isUnwrappedFlowChild(N, H, C) ? $ = this.flowShareOf(s, N, H, C, O) : (G === "Hug" && q && (this.constraintWasIndefinite = !0), $ = O);
      }
      return $ > 0 ? $ : null;
    }, h = {
      x: c("X") ? 1 / 0 : d("X") ? Math.max(0, (f(e, "X") ?? 1 / 0) - l.left - l.right) : Math.max(0, r.size.x - l.left - l.right),
      y: c("Y") ? 1 / 0 : d("Y") ? Math.max(0, (f(e, "Y") ?? 1 / 0) - l.top - l.bottom) : Math.max(0, r.size.y - l.top - l.bottom),
      z: c("Z") ? 1 / 0 : d("Z") ? Math.max(0, (f(e, "Z") ?? 1 / 0) - l.front - l.back) : Math.max(0, r.size.z - l.front - l.back)
    }, S = z(h, i), y = z(h, o), g = a.gap, p = a.crossGap ?? g, M = [];
    let I = {
      lines: [],
      crossASize: 0,
      crossBSize: 0
    }, m = {
      mainSize: 0,
      crossASize: 0,
      crossBSize: 0
    };
    const B = () => {
      if (m.mainSize <= 0 && m.crossASize <= 0 && m.crossBSize <= 0) return;
      const x = I.crossASize + (I.lines.length > 0 ? p : 0) + m.crossASize;
      x <= y || I.lines.length === 0 ? (I.lines.push(m), I.crossASize = x, I.crossBSize = Math.max(I.crossBSize, m.crossBSize)) : (M.push(I), I = {
        lines: [m],
        crossASize: m.crossASize,
        crossBSize: m.crossBSize
      }), m = {
        mainSize: 0,
        crossASize: 0,
        crossBSize: 0
      };
    };
    for (const x of t) {
      const C = x.layoutBox.size, w = z(C, i), k = z(C, o), X = z(C, n), Y = m.mainSize + (m.mainSize > 0 ? g : 0) + w;
      Y <= S || m.mainSize === 0 ? (m.mainSize = Y, m.crossASize = Math.max(m.crossASize, k), m.crossBSize = Math.max(m.crossBSize, X)) : (B(), m.mainSize = w, m.crossASize = k, m.crossBSize = X);
    }
    (m.mainSize > 0 || m.crossASize > 0 || m.crossBSize > 0) && B(), I.lines.length > 0 && M.push(I);
    let F = 0, P = 0, L = 0;
    for (let x = 0; x < M.length; x++) {
      const C = M[x];
      P = Math.max(P, C.crossASize), L += C.crossBSize, x > 0 && (L += p);
      for (const w of C.lines) F = Math.max(F, w.mainSize);
    }
    F += this.getMainPadding(i, l), P += this.getMainPadding(o, l), L += this.getMainPadding(n, l), r.sizeMode.x === "Hug" && (i === "X" ? r.size.x = F : o === "X" ? r.size.x = P : r.size.x = L), r.sizeMode.y === "Hug" && (i === "Y" ? r.size.y = F : o === "Y" ? r.size.y = P : r.size.y = L), r.sizeMode.z === "Hug" && (i === "Z" ? r.size.z = F : o === "Z" ? r.size.z = P : r.size.z = L);
  }
  resolve(e, t, s) {
    const i = s ? e.resolvedSize : e.layoutBox.size;
    e.resolvedSize = this.clampSize(i, e.layoutBox.min, e.layoutBox.max);
    const o = this.getOrderedChildren(t, e.id);
    if (o.length !== 0)
      if (e.layoutContainer) this.resolveContainer(e, o, t);
      else for (const n of o)
        n.resolvedPosition = { ...n.position }, this.resolve(n, t, !1);
  }
  resolveContainer(e, t, s) {
    const i = e.layoutContainer, [o, n] = K(i), a = this.getInnerSize(e.resolvedSize, i.padding), r = t.filter((c) => !this.isAbsolute(c)), l = t.filter((c) => this.isAbsolute(c)), u = this.fittedChild(e, r);
    if (u)
      i.resolvedWrap = !1, this.resolveFittedChild(e, u, s, a);
    else if (r.length > 0) {
      const c = i.wrap === !0;
      i.resolvedWrap = c, c ? this.resolveWrapped(e, r, s, a, i.directionAxis, o, n) : this.resolveNonWrapped(e, r, s, a, i.directionAxis, o, n);
    } else i.resolvedWrap = !1;
    l.length > 0 && this.resolveAbsoluteChildren(e, l, s, e.resolvedSize);
  }
  resolveAbsoluteChildren(e, t, s, i) {
    for (const o of t) {
      const n = o.layoutBox, a = this.getRelativeAxisPercent(o, "X"), r = this.getRelativeAxisPercent(o, "Y");
      a != null ? o.resolvedSize.x = i.x * (a / 100) : n.sizeMode.x === "Fill" ? o.resolvedSize.x = i.x : o.resolvedSize.x = n.size.x, r != null ? o.resolvedSize.y = i.y * (r / 100) : n.sizeMode.y === "Fill" ? o.resolvedSize.y = i.y : o.resolvedSize.y = n.size.y, n.sizeMode.z === "Fill" ? o.resolvedSize.z = i.z : o.resolvedSize.z = n.size.z, o.resolvedSize = this.clampSize(o.resolvedSize, n.min, n.max);
      const l = o.layoutItem?.inset;
      o.resolvedPosition = l ? {
        x: l.left ?? 0,
        y: l.top ?? 0,
        z: o.position.z
      } : { ...o.position }, this.resolve(o, s, !0);
    }
  }
  resolveNonWrapped(e, t, s, i, o, n, a) {
    const r = e.layoutContainer, l = r.padding;
    this.resolveChildSizes(t, i, o, n, a, r.gap, r.alignCrossA, r.alignCrossB);
    let u = 0;
    for (let h = 0; h < t.length; h++)
      u += z(t[h].resolvedSize, o), h > 0 && (u += r.gap);
    const c = z(i, o);
    let d = this.getStartOffset(l, o);
    d += this.calculateMainStartOffset(r.alignMain, c, u, t.length, r.gap);
    const f = this.calculateAdjustedGap(r.alignMain, c, u, t.length, r.gap);
    for (const h of t) {
      const S = h.layoutItem;
      let y = b();
      y = A(y, o, this.seatMain(o, d, z(h.resolvedSize, o), c, l));
      const g = S?.alignSelfCross ?? r.alignCrossA ?? "Start", p = this.calculateCrossOffset(g, z(i, n), z(h.resolvedSize, n), this.getStartOffset(l, n));
      y = A(y, n, p);
      const M = S?.alignSelfCrossB ?? r.alignCrossB ?? "Start", I = this.calculateCrossOffset(M, z(i, a), z(h.resolvedSize, a), this.getStartOffset(l, a));
      y = A(y, a, I), h.resolvedPosition = y, d += z(h.resolvedSize, o) + f, this.resolve(h, s, !0);
    }
  }
  resolveWrapped(e, t, s, i, o, n, a) {
    const r = e.layoutContainer;
    for (const f of t) f.resolvedSize = this.clampSize(f.layoutBox.size, f.layoutBox.min, f.layoutBox.max);
    const l = this.groupIntoLayers(t, i, o, n, a, r.gap, r.crossGap ?? r.gap), u = z(i, o), c = n.toLowerCase(), d = a.toLowerCase();
    for (const f of l) for (const h of f.lines) {
      this.resolveChildMainAxisSizesOnly(h.children, u, o, r.gap);
      let S = 0;
      for (let y = 0; y < h.children.length; y++)
        S += z(h.children[y].resolvedSize, o), y > 0 && (S += r.gap);
      h.mainSize = S;
      for (const y of h.children) {
        const g = y.layoutItem, p = y.layoutBox;
        (p.sizeMode[c] === "Fill" || (g?.alignSelfCross ?? r.alignCrossA) === "Stretch" && p.sizeMode[c] !== "Fixed") && h.crossASize > 1e-4 && (y.resolvedSize = A(y.resolvedSize, n, h.crossASize)), (p.sizeMode[d] === "Fill" || (g?.alignSelfCrossB ?? r.alignCrossB) === "Stretch" && p.sizeMode[d] !== "Fixed") && f.crossBSize > 1e-4 && (y.resolvedSize = A(y.resolvedSize, a, f.crossBSize)), y.resolvedSize = this.clampSize(y.resolvedSize, p.min, p.max);
      }
    }
    this.positionLayers(l, e, i, o, n, a, r, s);
  }
  groupIntoLayers(e, t, s, i, o, n, a) {
    const r = z(t, s), l = z(t, i), u = [];
    let c = {
      lines: [],
      crossASize: 0,
      crossBSize: 0
    }, d = {
      children: [],
      mainSize: 0,
      crossASize: 0,
      crossBSize: 0
    };
    for (const f of e) {
      const h = z(f.resolvedSize, s), S = z(f.resolvedSize, i), y = z(f.resolvedSize, o), g = d.mainSize + (d.children.length > 0 ? n : 0) + h;
      if (g <= r || d.children.length === 0)
        d.children.push(f), d.mainSize = g, d.crossASize = Math.max(d.crossASize, S), d.crossBSize = Math.max(d.crossBSize, y);
      else {
        const p = c.crossASize + (c.lines.length > 0 ? a : 0) + d.crossASize;
        p <= l || c.lines.length === 0 ? (c.lines.push(d), c.crossASize = p, c.crossBSize = Math.max(c.crossBSize, d.crossBSize)) : (u.push(c), c = {
          lines: [d],
          crossASize: d.crossASize,
          crossBSize: d.crossBSize
        }), d = {
          children: [f],
          mainSize: h,
          crossASize: S,
          crossBSize: y
        };
      }
    }
    return d.children.length > 0 && (c.lines.push(d), c.crossASize += (c.lines.length > 1 ? a : 0) + d.crossASize, c.crossBSize = Math.max(c.crossBSize, d.crossBSize)), c.lines.length > 0 && u.push(c), u;
  }
  positionLayers(e, t, s, i, o, n, a, r) {
    const l = a.padding, u = a.alignContentCrossA ?? "Start", c = a.alignContentCrossB ?? "Start", d = a.crossGap ?? a.gap;
    let f = 0;
    for (let g = 0; g < e.length; g++)
      f += e[g].crossBSize, g > 0 && (f += d);
    const h = z(s, n);
    let S = this.getStartOffset(l, n);
    S += this.calculateMainStartOffset(c, h, f, e.length, d);
    const y = this.calculateAdjustedGap(c, h, f, e.length, d);
    for (const g of e) {
      let p = 0;
      for (let B = 0; B < g.lines.length; B++)
        p += g.lines[B].crossASize, B > 0 && (p += d);
      const M = z(s, o);
      let I = this.getStartOffset(l, o);
      I += this.calculateMainStartOffset(u, M, p, g.lines.length, d);
      const m = this.calculateAdjustedGap(u, M, p, g.lines.length, d);
      for (const B of g.lines) {
        const F = z(s, i);
        let P = this.getStartOffset(l, i);
        P += this.calculateMainStartOffset(a.alignMain, F, B.mainSize, B.children.length, a.gap);
        const L = this.calculateAdjustedGap(a.alignMain, F, B.mainSize, B.children.length, a.gap);
        for (const x of B.children) {
          const C = x.layoutItem, w = C?.alignSelfCross ?? a.alignCrossA ?? "Start", k = C?.alignSelfCrossB ?? a.alignCrossB ?? "Start", X = this.calculateCrossOffset(w, B.crossASize, z(x.resolvedSize, o), 0), Y = this.calculateCrossOffset(k, g.crossBSize, z(x.resolvedSize, n), 0);
          let E = b();
          E = A(E, i, this.seatMain(i, P, z(x.resolvedSize, i), F, l)), E = A(E, o, I + X), E = A(E, n, S + Y), x.resolvedPosition = E, P += z(x.resolvedSize, i) + L, this.resolve(x, r, !0);
        }
        I += B.crossASize + m;
      }
      S += g.crossBSize + y;
    }
  }
  resolveChildSizes(e, t, s, i, o, n, a, r) {
    const l = z(t, s), { flexes: u, childFlexMap: c } = this.buildFlexInputs(e, s, l), d = D(u, l, n);
    for (const f of u) {
      const { child: h, minMain: S, maxMain: y } = c.get(f.id), g = h.layoutItem, p = h.layoutBox;
      let M = { ...p.size };
      const I = se(d.get(h.id) ?? f.baseMain, S, y);
      M = A(M, s, I);
      const m = i.toLowerCase(), B = z(t, i), F = this.getRelativeAxisPercent(h, i), P = g?.alignSelfCross ?? a;
      F != null ? M = A(M, i, B * (F / 100)) : (p.sizeMode[m] === "Fill" || P === "Stretch" && p.sizeMode[m] !== "Fixed") && B > 1e-4 && (M = A(M, i, B));
      const L = o.toLowerCase(), x = z(t, o), C = this.getRelativeAxisPercent(h, o), w = g?.alignSelfCrossB ?? r;
      C != null ? M = A(M, o, x * (C / 100)) : (p.sizeMode[L] === "Fill" || w === "Stretch" && p.sizeMode[L] !== "Fixed") && x > 1e-4 && (M = A(M, o, x)), h.resolvedSize = this.clampSize(M, p.min, p.max);
    }
  }
  resolveChildMainAxisSizesOnly(e, t, s, i) {
    const o = s.toLowerCase(), n = [];
    for (const r of e) {
      const l = r.layoutItem, u = r.layoutBox, c = this.getRelativeAxisPercent(r, s), d = c != null ? "Fixed" : l?.mainAxisMode ?? u.sizeMode[o], f = l?.flexBasis ?? null, h = c != null ? t * c / 100 : z(r.resolvedSize, s), S = c != null ? h : f ?? (d === "Fill" ? 0 : h), y = l?.flexGrow ?? (d === "Fill" ? 1 : 0), g = l?.flexShrink ?? 1, p = te(d, z(u.min, s), h, !!(s === "X" ? u.minExplicitX : s === "Y" ? u.minExplicitY : u.minExplicitZ), r.layoutContainer?.clipContent === !0, this.hasMeasuredContentFloor(r, s));
      n.push({
        id: r.id,
        baseMain: S,
        grow: Math.max(0, y),
        shrink: Math.max(0, g),
        minMain: p,
        maxMain: z(u.max, s)
      });
    }
    const a = D(n, t, i);
    for (let r = 0; r < e.length; r++) {
      const l = e[r], u = n[r], c = l.layoutBox, d = Math.min(u.maxMain, Math.max(u.minMain, a.get(l.id) ?? u.baseMain));
      l.resolvedSize = this.clampSize(A(l.resolvedSize, s, d), c.min, c.max);
    }
  }
  fittedChild(e, t) {
    const s = e.layoutContainer;
    return !s?.contentFit || s.wrap === !0 || t.length !== 1 ? null : t[0];
  }
  flowBox(e, t) {
    const s = e.flowScale;
    return s === void 0 ? t : {
      x: t.x * s,
      y: t.y * s,
      z: t.z * s
    };
  }
  resolveFittedChild(e, t, s, i) {
    const o = e.layoutContainer, n = o.padding, [a, r] = K(o), l = o.directionAxis, u = t.layoutBox;
    t.resolvedSize = this.clampSize(u.size, u.min, u.max), t.flowScale = ee(o.contentFit, t.resolvedSize, {
      x: e.layoutBox.sizeMode.x === "Hug" ? null : i.x,
      y: e.layoutBox.sizeMode.y === "Hug" ? null : i.y
    });
    const c = this.flowBox(t, t.resolvedSize), d = z(i, l), f = z(c, l), h = this.getStartOffset(n, l) + this.calculateMainStartOffset(o.alignMain, d, f, 1, o.gap);
    let S = b();
    S = A(S, l, this.seatMain(l, h, f, d, n)), S = A(S, a, this.calculateCrossOffset(t.layoutItem?.alignSelfCross ?? o.alignCrossA ?? "Start", z(i, a), z(c, a), this.getStartOffset(n, a))), S = A(S, r, this.calculateCrossOffset(t.layoutItem?.alignSelfCrossB ?? o.alignCrossB ?? "Start", z(i, r), z(c, r), this.getStartOffset(n, r))), t.resolvedPosition = S, this.resolve(t, s, !0);
  }
  clampSize(e, t, s) {
    return {
      x: Math.max(t.x, Math.min(s.x, e.x)),
      y: Math.max(t.y, Math.min(s.y, e.y)),
      z: Math.max(t.z, Math.min(s.z, e.z))
    };
  }
  getInnerSize(e, t) {
    return {
      x: Math.max(0, e.x - t.left - t.right),
      y: Math.max(0, e.y - t.top - t.bottom),
      z: Math.max(0, e.z - t.front - t.back)
    };
  }
  getMainPadding(e, t) {
    switch (e) {
      case "X":
        return t.left + t.right;
      case "Y":
        return t.top + t.bottom;
      case "Z":
        return t.front + t.back;
    }
  }
  getStartOffset(e, t) {
    switch (t) {
      case "X":
        return e.left;
      case "Y":
        return e.top;
      case "Z":
        return e.front;
    }
  }
  seatMain(e, t, s, i, o) {
    return e !== "Z" ? t : o.front + i + o.back - t - s;
  }
  calculateMainStartOffset(e, t, s, i, o) {
    switch (e) {
      case "Start":
        return 0;
      case "Center":
        return (t - s) / 2;
      case "End":
        return t - s;
      case "SpaceBetween":
        return 0;
      case "SpaceAround":
        return i > 0 ? (t - s + o * (i - 1)) / (i * 2) : 0;
      case "SpaceEvenly": {
        const n = s - o * (i - 1);
        return i > 0 ? (t - n) / (i + 1) : 0;
      }
    }
  }
  calculateAdjustedGap(e, t, s, i, o) {
    if (i <= 1) return o;
    switch (e) {
      case "SpaceBetween":
        return (t - (s - o * (i - 1))) / (i - 1);
      case "SpaceAround":
        return (t - (s - o * (i - 1))) / i;
      case "SpaceEvenly":
        return (t - (s - o * (i - 1))) / (i + 1);
      default:
        return o;
    }
  }
  calculateCrossOffset(e, t, s, i) {
    switch (e) {
      case "Start":
        return i;
      case "Center":
        return i + (t - s) / 2;
      case "End":
        return i + t - s;
      case "Stretch":
        return i;
    }
  }
}, Me = class {
  nodes = /* @__PURE__ */ new Map();
  rootIds = /* @__PURE__ */ new Set();
  addNode(e, t) {
    if (this.nodes.set(e.id, e), t) {
      const s = this.nodes.get(t);
      s ? (e.parentId = t, s.childrenIds.includes(e.id) || s.childrenIds.push(e.id), s.layoutContainer && !e.layoutItem && (e.layoutItem = Q())) : (e.parentId = null, this.rootIds.add(e.id));
    } else
      e.parentId = null, this.rootIds.add(e.id);
  }
  removeNode(e) {
    const t = this.nodes.get(e);
    if (!t) return null;
    for (const s of t.childrenIds) {
      const i = this.nodes.get(s);
      if (i)
        if (i.parentId = t.parentId, t.parentId) {
          const o = this.nodes.get(t.parentId);
          o && !o.childrenIds.includes(s) && o.childrenIds.push(s);
        } else this.rootIds.add(s);
    }
    if (t.parentId) {
      const s = this.nodes.get(t.parentId);
      s && (s.childrenIds = s.childrenIds.filter((i) => i !== e));
    } else this.rootIds.delete(e);
    return this.nodes.delete(e), t;
  }
  getNode(e) {
    return this.nodes.get(e);
  }
  getRoots() {
    return Array.from(this.rootIds).map((e) => this.nodes.get(e)).filter((e) => e !== void 0);
  }
  getChildren(e) {
    const t = this.nodes.get(e);
    return t ? t.childrenIds.map((s) => this.nodes.get(s)).filter((s) => s !== void 0) : [];
  }
  getAllNodes() {
    return Array.from(this.nodes.values());
  }
  reparent(e, t) {
    this.reparentAt(e, t, null);
  }
  reparentAt(e, t, s) {
    const i = this.nodes.get(e);
    if (!i) return;
    const o = i.parentId;
    if (t && t !== o && this.isDescendant(t, e)) return;
    let n = s;
    if (o === t && s != null) if (o) {
      const a = this.nodes.get(o);
      if (a) {
        const r = a.childrenIds.indexOf(e);
        r >= 0 && s > r && (n = s - 1);
      }
    } else {
      const a = Array.from(this.rootIds).indexOf(e);
      a >= 0 && s > a && (n = s - 1);
    }
    if (i.parentId) {
      const a = this.nodes.get(i.parentId);
      a && (a.childrenIds = a.childrenIds.filter((r) => r !== e));
    } else this.rootIds.delete(e);
    if (t) {
      const a = this.nodes.get(t);
      a ? (i.parentId = t, a.childrenIds = a.childrenIds.filter((r) => r !== e), a.childrenIds.splice(Math.max(0, Math.min(a.childrenIds.length, n ?? a.childrenIds.length)), 0, e)) : (i.parentId = null, this.rootIds.add(e));
    } else if (i.parentId = null, n == null) this.rootIds.add(e);
    else {
      const a = Array.from(this.rootIds).filter((r) => r !== e);
      a.splice(Math.max(0, Math.min(a.length, n)), 0, e), this.rootIds = new Set(a);
    }
  }
  isDescendant(e, t) {
    let s = this.nodes.get(t);
    for (; s; ) {
      if (s.parentId === e) return !0;
      s = s.parentId ? this.nodes.get(s.parentId) : void 0;
    }
    return !1;
  }
  groupNodes(e) {
    if (e.length === 0) return null;
    const t = e.map((n) => this.nodes.get(n)).filter((n) => n !== void 0);
    if (t.length === 0) return null;
    const s = le(), i = t[0].parentId, o = this.computeGroupBounds(t);
    s.layoutBox.size = o.size, s.position = o.position, this.addNode(s, i ?? void 0);
    for (const n of t)
      n.position = {
        x: n.resolvedPosition.x - o.position.x,
        y: n.resolvedPosition.y - o.position.y,
        z: n.resolvedPosition.z - o.position.z
      }, this.reparent(n.id, s.id);
    return s;
  }
  ungroup(e) {
    const t = this.nodes.get(e);
    if (!t || t.childrenIds.length === 0) return;
    const s = t.parentId;
    for (const i of [...t.childrenIds]) {
      const o = this.nodes.get(i);
      o && (o.position = {
        x: o.resolvedPosition.x + t.resolvedPosition.x,
        y: o.resolvedPosition.y + t.resolvedPosition.y,
        z: o.resolvedPosition.z + t.resolvedPosition.z
      }, this.reparent(i, s));
    }
    this.removeNode(e);
  }
  convertToAutoLayout(e) {
    const t = this.nodes.get(e);
    if (t) {
      t.layoutContainer = re();
      for (const s of t.childrenIds) {
        const i = this.nodes.get(s);
        i && !i.layoutItem && (i.layoutItem = Q());
      }
    }
  }
  removeAutoLayout(e) {
    const t = this.nodes.get(e);
    if (t) {
      t.layoutContainer = null;
      for (const s of t.childrenIds) {
        const i = this.nodes.get(s);
        i && (i.layoutItem = null);
      }
    }
  }
  computeGroupBounds(e) {
    if (e.length === 0) return {
      position: b(),
      size: b(100, 100, 100)
    };
    let t = 1 / 0, s = 1 / 0, i = 1 / 0, o = -1 / 0, n = -1 / 0, a = -1 / 0;
    for (const r of e) {
      const l = r.resolvedPosition, u = r.resolvedSize;
      t = Math.min(t, l.x), s = Math.min(s, l.y), i = Math.min(i, l.z), o = Math.max(o, l.x + u.x), n = Math.max(n, l.y + u.y), a = Math.max(a, l.z + u.z);
    }
    return {
      position: {
        x: t,
        y: s,
        z: i
      },
      size: {
        x: o - t,
        y: n - s,
        z: a - i
      }
    };
  }
  traverse(e) {
    const t = (s, i) => {
      const o = this.nodes.get(s);
      if (o) {
        e(o, i);
        for (const n of o.childrenIds) t(n, i + 1);
      }
    };
    for (const s of this.rootIds) t(s, 0);
  }
  traverseBottomUp(e) {
    const t = (s) => {
      const i = this.nodes.get(s);
      if (i) {
        for (const o of i.childrenIds) t(o);
        e(i);
      }
    };
    for (const s of this.rootIds) t(s);
  }
  toJSON() {
    return Array.from(this.nodes.values());
  }
  fromJSON(e) {
    this.nodes.clear(), this.rootIds.clear();
    for (const t of e) this.nodes.set(t.id, t);
    for (const t of e) t.parentId || this.rootIds.add(t.id);
  }
};
export {
  re as a,
  ne as c,
  xe as i,
  b as l,
  me as n,
  Q as o,
  K as r,
  le as s,
  Me as t
};

//# sourceMappingURL=LayoutTree-BYNW_PVs.js.map